<script>
import { mapActions, mapMutations } from "vuex";
import ContactAgentDialog from "../common/contactAgentDialog.vue";

export default {
  name: "listingDetails",
  data() {
    return {
      contactDialogVisible: false,
      loading: false,
      rules: {
        name: {
          required: true,
          message: "Please enter your name",
          trigger: "blur"
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,20}$/
        },
        phoneNumber: {
          required: true,
          message: "Please enter phone number",
          trigger: "blur"
        },
        message: {
          required: true,
          message: "Please enter message",
          trigger: "blur"
        }
      },
      form: {
        name: "",
        email: "",
        phoneNumber: "",
        message: ""
      },
      activeNames: ["1"],
      pid: "",
      apartment: "Apartments",
      townhouse: "Townhouses",
      house: "House",
      houseLand: "House & Land",
      landOnly: "Land",

      shareDialogVisible: false,
      shareList: [
        {
          title: "Facebook",
          class: "fb-ico",
          id: "facebook"
        },
        {
          title: "Twitter",
          class: "tw-ico",
          id: "twitter"
        },
        {
          title: "Email",
          class: "email-ico",
          id: "email"
        },
        {
          title: "Copy Link",
          class: "copy-ico",
          id: "copy"
        }
      ],
      emailContent: ""
    };
  },
  props: {
    listingDetails: Object,
    currentRoom: Object
  },
  components: {ContactAgentDialog},
  created() {
    let url = document.location.href;
    this.emailContent =
      "mailto:team@unifiproperty.com?subject=Share UNIFI property&body=" +
      "" +
      url +
      "%0d%0a";
  },
  methods: {
    ...mapActions("contact", ["contact"]),
    ...mapActions("home", ["postCollect", "cancelCollect"]),
    ...mapMutations("home", ["setList"]),
    ...mapMutations("property", ["collect"]),
    operate(id) {
      if (id == "facebook" || id == "twitter") {
        this.share(id);
      } else if (id == "copy") {
        var href = document.location.href;
        navigator.clipboard.writeText(href).then(() => {
          this.$box.alert("", "Copied successfully", "success");
        });
      }
    },
    share(type) {
      //??
      var toOpen = function(url) {
        var option =
          "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350";
        window.open(url, "_blank", option);
      };
      var href = document.location.href;
      var title = this.listingDetails.address;
      switch (type) {
        case "facebook": //???Facebook???
          toOpen(
            "http://www.facebook.com/sharer.php?u=" + href + "&t=" + title
          );
          break;
        case "google": //???Google???
          toOpen(
            "http://www.google.com/bookmarks/mark?op=add&bkmk=" +
              href +
              "&title=" +
              title
          );
          break;
        case "twitter": //???twitter???
          toOpen("https://twitter.com/intent/tweet?text=" + href);
          break;
        case "yahoo": //???yahoo
          toOpen(
            "http://myweb2.search.yahoo.com/myresults/bookmarklet?u=" +
              href +
              "&t=" +
              title
          );
          break;
        case "linkedin": //???linkedin
          toOpen(
            "http://www.linkedin.com/shareArticle?mini=true&url=" +
              href +
              "&title=" +
              title
          );
          break;
      }
    },
    validate(filed) {
      if (filed === "phone") {
        this.form.phoneNumber = this.form.phoneNumber.replace(/[^\d]/g, "");
      }
    },
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        that.$box.alert("", "Successfully submitted", "success");
        that.closeContact();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    handleChange(val) {
      console.log(val);
    },
    reserveTheProperty2() {
      this.$router.push({
        path: "/property/reservation/",
        query: { pid: this.$route.query.pid, type: 2 }
      });
    },
    handleBrochureClick() {
      window.open(this.listingDetails.brochure, "_blank");
    },
    collectOperate(type, id) {
      var that = this;
      console.log(type);
      console.log(id);
      if (type == null) {
        that.$router.push({ name: "newloginpage" });
      }

      if (type == "no") {
        that.postCollect({
          params: { propertyId: id },
          callback: that.collcectCallback
        });
      } else {
        that.cancelCollect({
          params: { propertyId: id },
          callback: that.cancelCallback
        });
      }
    },
    collcectCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: "no" });
        that.$forceUpdate();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    cancelCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: "yes" });
        that.$forceUpdate();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    displayLandPrice() {
      let rent = this.listingDetails.landPrice;
      let rentMax = this.listingDetails.landPriceMax;

      if (
        (rent == null && rentMax == null) ||
        (rent == 0 && rentMax == 0) ||
        (rent == "" && rentMax == "") ||
        (rent == 0 && rentMax == null) ||
        (rent == null && rentMax == 0)
      ) {
        return "TBA";
      } else if (parseInt(rent) > 0 && rentMax == null) {
        return "$" + rent;
      } else if (parseInt(rent) > 0 && parseInt(rentMax) > 0) {
        return "$" + rent + " - " + "$" + rentMax;
      } else if (rent == null && parseInt(rentMax) > 0) {
        return "$" + rentMax;
      } else {
        return parseInt(rent) > parseInt(rentMax)
          ? "$" + rent
          : "$" + rent + " - " + "$" + rentMax;
      }
    },
    displayBuildPrice() {
      let rent = this.listingDetails.buildPrice;
      let rentMax = this.listingDetails.buildPriceMax;

      if (
        (rent == null && rentMax == null) ||
        (rent == 0 && rentMax == 0) ||
        (rent == "" && rentMax == "") ||
        (rent == 0 && rentMax == null) ||
        (rent == null && rentMax == 0)
      ) {
        return "TBA";
      } else if (parseInt(rent) > 0 && rentMax == null) {
        return "$" + rent;
      } else if (parseInt(rent) > 0 && parseInt(rentMax) > 0) {
        return "$" + rent + " - " + "$" + rentMax;
      } else if (rent == null && parseInt(rentMax) > 0) {
        return "$" + rentMax;
      } else {
        return parseInt(rent) > parseInt(rentMax)
          ? "$" + rent
          : "$" + rent + " - " + "$" + rentMax;
      }
    },
    getLandSizeValue() {
      let size = this.listingDetails.labdSize;
      let sizeMax = this.listingDetails.landSizeMax;
      if (
        (size == null && sizeMax == null) ||
        (size == 0 && sizeMax == 0) ||
        (size == "" && sizeMax == "") ||
        (size == 0 && sizeMax == null) ||
        (size == null && sizeMax == 0)
      ) {
        return "TBA";
      } else if (parseFloat(size) > 0 && sizeMax == null) {
        return size + " m\u00B2";
      } else if (parseFloat(size) > 0 && parseFloat(sizeMax) > 0) {
        return size + " m\u00B2" + " - " + sizeMax + " m\u00B2";
      } else if (size == null && parseFloat(sizeMax) > 0) {
        return sizeMax + " m\u00B2";
      } else {
        return parseFloat(size) > parseFloat(sizeMax)
          ? size + " m\u00B2"
          : size + " m\u00B2" + " - " + sizeMax + " m\u00B2";
      }
    },
    shareAction() { }
  }
};
</script>

<template>
  <div>
    <contact-agent-dialog v-if="contactDialogVisible"
                          :contact-dialog-visible.sync="contactDialogVisible"
                          :property-id="listingDetails.propertyId"></contact-agent-dialog>
    <el-dialog
      :show-close="false"
      :visible.sync="shareDialogVisible"
      center
      custom-class="share-dialog"
      title=""
      width="90%"
    >
      <template #title>
        <div class="share-title">
          Share this listing
          <div class="icon" @click="shareDialogVisible = !shareDialogVisible">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </template>
      <div class="share-list">
        <ul>
          <li
            v-for="item in shareList"
            :key="item.class"
            :class="item.class"
            @click="operate(item.id)"
          >
            <a v-if="item.id == 'email'" :href="emailContent" target="_balnk">{{
              item.title
            }}</a>
            <span v-else>{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </el-dialog>

    <el-row style="padding: 20px 0; background-color: #ffffff">
      <el-col :span="24">
        <el-row
          style="margin-bottom: 10px; display: flex; align-items: center; padding: 0 5px"
        >
          <el-col :span="12">
            <span class="gray-chip">{{ listingDetails.proertyType }}</span>
          </el-col>
          <el-col :span="12" style="display: flex; justify-content: flex-end">
            <div v-track:104.click="shareAction">
              <el-image class="share-button" :src="require('../../assets/share-2.svg')"
                @click="shareDialogVisible = true" />
            </div>
<!--            <div v-track:103.click="shareAction"-->
<!--              style="margin-left:10px;cursor: pointer;display: flex;align-items: center;"-->
<!--              v-if="listingDetails.favoritesFlag == null || listingDetails.favoritesFlag == 'no'">-->
<!--              <el-image @click="collectOperate(listingDetails.favoritesFlag, listingDetails.propertyId)"-->
<!--                :src="require('../../assets/star.svg')" />-->
<!--            </div>-->
<!--            <el-image v-else @click="collectOperate(listingDetails.favoritesFlag, listingDetails.propertyId)"-->
<!--              :src="require('../../assets/star-fill.svg')" style="margin-left: 10px;cursor: pointer;" />-->
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px; padding: 0 5px">
          <el-col :span="24">
            <span class="address-text">{{
              listingDetails.address && listingDetails.suburb
                ? listingDetails.address.trim() + ", " + listingDetails.suburb
                : listingDetails.address || listingDetails.suburb
                ? listingDetails.address || listingDetails.suburb
                : "TBA"
            }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px; padding: 0 5px">
          <el-col :span="24">
            <span class="state-text"
              >{{ listingDetails.state }} {{ listingDetails.postcode }}</span
            >
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px; padding: 0 5px">
          <el-col
            v-if="listingDetails.price == 0 && listingDetails.price == 0"
            :span="24"
            ><span class="div-22">Make an offer</span>
          </el-col>
          <el-col v-else :span="24">
            <span class="price-text">
              {{ listingDetails.price != 0 ? "$" + listingDetails.price : "" }}
              {{
                listingDetails.maxPrice != 0
                  ? " - $" + listingDetails.maxPrice
                  : ""
              }}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="background-color: #ffffff; padding: 10px 0">
            <el-row
              v-if="
                listingDetails.proertyType == apartment ||
                  listingDetails.proertyType == houseLand ||
                  listingDetails.proertyType == townhouse ||
                  listingDetails.proertyType == house
              "
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title"
                >Estimated Commencement</el-col
              >
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.estimatedCommenceMent == "" ||
                  listingDetails.estimatedCommenceMent == null
                    ? "TBA"
                    : listingDetails.estimatedCommenceMent
                }}
              </el-col>
            </el-row>
            <el-row
              v-if="
                listingDetails.proertyType == apartment ||
                  listingDetails.proertyType == townhouse ||
                  listingDetails.proertyType == house ||
                  listingDetails.proertyType == houseLand
              "
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Estimated Completion</el-col>
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.estimatedCompletion == "" ||
                  listingDetails.estimatedCompletion == undefined ||
                  listingDetails.estimatedCompletion == null
                    ? "TBA"
                    : listingDetails.estimatedCompletion
                }}
              </el-col>
            </el-row>
            <el-row
              v-if="listingDetails.proertyType == houseLand"
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Land Price</el-col>
              <el-col :span="15" class="desc-lbl">
                <span>{{ displayLandPrice(listingDetails) }}</span>
              </el-col>
            </el-row>
            <el-row
              v-if="listingDetails.proertyType == houseLand"
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Build Price</el-col>
              <el-col :span="15" class="desc-lbl">
                <span>{{ displayBuildPrice(listingDetails) }}</span>
              </el-col>
            </el-row>
            <el-row
              v-if="listingDetails.proertyType == landOnly"
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Land Size</el-col>
              <el-col :span="15" class="desc-lbl">
                <span>{{ getLandSizeValue(listingDetails) }}</span>
              </el-col>
            </el-row>
            <el-row
              v-if="listingDetails.proertyType == landOnly"
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Title Issued</el-col>
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.titlesIssued == 0 ||
                  listingDetails.titlesIssued == "" ||
                  listingDetails.titlesIssued == undefined ||
                  listingDetails.titlesIssued == null
                    ? "TBA"
                    : listingDetails.titlesIssued
                }}
              </el-col>
            </el-row>
            <el-row
              v-if="listingDetails.proertyType == landOnly"
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Estimated Settled</el-col>
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.estimatedSettled == 0 ||
                  listingDetails.estimatedSettled == "" ||
                  listingDetails.estimatedSettled == undefined ||
                  listingDetails.estimatedSettled == null
                    ? "TBA"
                    : listingDetails.estimatedSettled
                }}
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              style="margin-bottom: 10px; display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Contract Type</el-col>
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.contractType == 0 ||
                  listingDetails.contractType == null
                    ? "TBA"
                    : listingDetails.contractType
                }}
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              style="display: flex; align-items: baseline"
            >
              <el-col :span="9" class="desc-title">Incentives</el-col>
              <el-col :span="15" class="desc-lbl">
                {{
                  listingDetails.incentives == 0 ||
                  listingDetails.incentives == null
                    ? "TBA"
                    : listingDetails.incentives
                }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding: 10px 5px 5px 5px">
          <el-col
            :span="24"
            style="display: flex; flex-direction: column;"
          >
            <el-button
              class="btn-contact-agent"
              @click="contactDialogVisible = true"
            >Enquire
            </el-button>
          </el-col>
        </el-row>
        <el-row style="padding: 5px 5px 10px 5px">
          <el-col
            :span="24"
            style="display: flex; flex-direction: column;"
          >
<!--            <el-button class="btn-reserve" v-track:101.click="reserveTheProperty2">-->
<!--              Reserve-->
<!--            </el-button>-->
          </el-col>
        </el-row>
        <el-row style="padding: 10px 0">
          <el-col :span="24">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item name="1">
                <template slot="title"
                  ><span class="font-style-collapse" style="padding: 0 5px;"
                    >Description</span
                  >
                </template>
                <el-row :gutter="20" style="padding: 10px">
                  <el-col :span="24">
                      <span
                        class="font-style-desc"
                        style="white-space: pre-wrap;"
                        >{{ listingDetails.description }}</span
                      >
                  </el-col>
                </el-row>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title"
                  ><span class="font-style-collapse" style="padding: 0 5px;"
                    >Features</span
                  >
                </template>
                <el-row :gutter="20" style="padding: 10px">
                  <el-col :span="24">
                      <span
                        class="font-style-desc"
                        style="white-space: pre-wrap;"
                        >{{ listingDetails.features }}</span
                      >
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
        <el-row v-if="listingDetails.brochure" style="padding: 10px 5px">
          <el-col :span="24" style="display: flex; flex-direction: column">
            <el-button class="btn-download" @click="handleBrochureClick"
              >Download Brochure</el-button
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.gray-chip {
  color: #003333;
  white-space: nowrap;
  justify-content: center;
  border-radius: 30px;
  background-color: #cccccc;
  align-self: start;
  padding: 10px 20px;
  font: 400 16px DINosaur-a, sans-serif;
}

.address-text {
  font: 600 34px DINosaur-a, sans-serif;
  color: #003333;
  line-height: 117.647%;
}

.price-text {
  margin-top: 18px;
  font: 400 24px DINosaur-a, sans-serif;
  color: #003333;
}

.state-text {
  margin-top: 12px;
  font: 400 18px/111.111% DINosaur-a, sans-serif;
  color: #003333;
}

.desc-title {
  color: #0000007f;
  text-align: end;
  font: 400 16px/125% DINosaur-a, sans-serif;
}

.desc-lbl {
  color: #003333;
  text-align: start;
  font: 400 16px/125% DINosaur-a, sans-serif;
}

.btn-reserve {
  font-family: DINosaur-a, sans-serif;
  border-radius: 5px;
  background-color: #003333;
  color: #ffffff;
  justify-content: center;
  border: 4px solid #003333;
}

.btn-contact-agent {
  font-family: DINosaur-a, sans-serif;
  border-radius: 5px;
  background-color: #ffffff;
  color: #003333;
  justify-content: center;
  border: 4px solid #cccccc;
}

.el-collapse {
  border-top: none;
}

.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #ffffff;
  color: #003333;
}

.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #ffffff;
}

.el-collapse-item /deep/ .el-collapse-item__content {
  color: #003333;
}

.font-style-collapse {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.font-style-desc {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  display: block;
  word-wrap: break-word;
}

.btn-download {
  font-family: DINosaur-a, sans-serif;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 4px solid #cccccc;
  background-color: #ffffff;
  color: #003333;
  padding: 10px 0;
}

.share-button {
  cursor: pointer;
}

.share-title {
  text-align: left;
  font-size: 22px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 600;
}

.share-title .icon {
  float: right;
  width: 35px;
  height: 35px;
  font-size: 35px;
  cursor: pointer;
  color: #003333;
  position: relative;
  top: -15px;
  right: -10px;
}

.share-list ul {
  background-color: transparent;
}

.share-list ul li {
  box-sizing: border-box;
  padding-left: 80px;
  font-size: 17px;
  font-family: DINosaur-a, sans-serif;
  color: #22668b;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 55px auto;
  line-height: 55px;
  margin-bottom: 20px;
  list-style-type: none;
  font-weight: 600;
}

.share-list ul li a {
  text-decoration: none;
  color: #22668b;
  font-weight: 600;
}

.share-list ul li.fb-ico {
  background-image: url("../../assets/facebook.png");
}

.share-list ul li.tw-ico {
  background-image: url("../../assets/twitter.png");
}

.share-list ul li.email-ico {
  background-image: url("../../assets/email.png");
}

.share-list ul li.copy-ico {
  background-image: url("../../assets/copy.png");
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/listingDetails.vue